"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SimpleAPIData_1 = require("./SimpleAPIData");
var SimpleAPIResponse_1 = require("./SimpleAPIResponse");
var SimpleAPITransformer = /** @class */ (function () {
    function SimpleAPITransformer() {
    }
    /**
     *  Check to see if the object provided is a SimpleAPIResponse
     * @param simpleAPIResponse {SimpleAPIData}
     * @returns {Boolean}
     */
    SimpleAPITransformer.isSimpleAPIResponse = function (simpleAPIResponse) {
        return simpleAPIResponse instanceof SimpleAPIResponse_1.SimpleAPIResponse;
    };
    /**
     * Check to see if the object provide is a SimpleAPIData.
     * @param simpleAPIData {SimpleAPIData}
     * @returns {Boolean}
     */
    SimpleAPITransformer.isSimpleAPIData = function (simpleAPIData) {
        return simpleAPIData instanceof SimpleAPIData_1.SimpleAPIData;
    };
    /**
     * the internal logic to transform an APIResponse into a data collection
     * @param simpleAPIResponse {SimpleAPIResponse}
     * @param singleOnly {Boolean}
     * @returns {any|null}
     */
    SimpleAPITransformer.prototype.processTransformResponse = function (simpleAPIResponse, singleOnly) {
        /*
         * Return an empty collection if the response is not valid
         */
        if (!SimpleAPITransformer.isSimpleAPIResponse(simpleAPIResponse)) {
            return [];
        }
        var data = null;
        /*
         * If the processing is for a single response only.
         */
        if (singleOnly) {
            data = simpleAPIResponse.getSingleData();
            return this.transformData(data);
        }
        else {
            /*
             * Process a batch of responses via getData
             */
            data = simpleAPIResponse.getData();
            var output = [];
            for (var i in data) {
                if (data.hasOwnProperty(i) &&
                    SimpleAPITransformer.isSimpleAPIData(data[i])) {
                    var transformed = this.transformData(data);
                    if (transformed != null) {
                        output.push(transformed);
                    }
                }
            }
            return output;
        }
    };
    return SimpleAPITransformer;
}());
exports.SimpleAPITransformer = SimpleAPITransformer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2ltcGxlQVBJVHJhbnNmb3JtZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvQVBJL1NpbXBsZUFQSS9TaW1wbGVBUElUcmFuc2Zvcm1lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlEQUFnRDtBQUNoRCx5REFBd0Q7QUFFeEQ7SUFBQTtJQWdGQSxDQUFDO0lBL0VDOzs7O09BSUc7SUFDSSx3Q0FBbUIsR0FBMUIsVUFBMkIsaUJBQWlCO1FBQzFDLE9BQU8saUJBQWlCLFlBQVkscUNBQWlCLENBQUM7SUFDeEQsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxvQ0FBZSxHQUF0QixVQUF1QixhQUFhO1FBQ2xDLE9BQU8sYUFBYSxZQUFZLDZCQUFhLENBQUM7SUFDaEQsQ0FBQztJQW9CRDs7Ozs7T0FLRztJQUNPLHVEQUF3QixHQUFsQyxVQUNFLGlCQUFvQyxFQUNwQyxVQUFVO1FBRVY7O1dBRUc7UUFDSCxJQUFJLENBQUMsb0JBQW9CLENBQUMsbUJBQW1CLENBQUMsaUJBQWlCLENBQUMsRUFBRTtZQUNoRSxPQUFPLEVBQUUsQ0FBQztTQUNYO1FBQ0QsSUFBSSxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ2hCOztXQUVHO1FBQ0gsSUFBSSxVQUFVLEVBQUU7WUFDZCxJQUFJLEdBQUcsaUJBQWlCLENBQUMsYUFBYSxFQUFFLENBQUM7WUFDekMsT0FBTyxJQUFJLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQ2pDO2FBQU07WUFDTDs7ZUFFRztZQUNILElBQUksR0FBRyxpQkFBaUIsQ0FBQyxPQUFPLEVBQUUsQ0FBQztZQUNuQyxJQUFNLE1BQU0sR0FBRyxFQUFFLENBQUM7WUFDbEIsS0FBSyxJQUFNLENBQUMsSUFBSSxJQUFJLEVBQUU7Z0JBQ3BCLElBQ0UsSUFBSSxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUM7b0JBQ3RCLG9CQUFvQixDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFDN0M7b0JBQ0EsSUFBTSxXQUFXLEdBQUcsSUFBSSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsQ0FBQztvQkFDN0MsSUFBSSxXQUFXLElBQUksSUFBSSxFQUFFO3dCQUN2QixNQUFNLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxDQUFDO3FCQUMxQjtpQkFDRjthQUNGO1lBQ0QsT0FBTyxNQUFNLENBQUM7U0FDZjtJQUNILENBQUM7SUFDSCwyQkFBQztBQUFELENBQUMsQUFoRkQsSUFnRkM7QUFoRnFCLG9EQUFvQiJ9